import React from 'react';
import { observer } from 'mobx-react';

import { routeNaming, AppRedirect } from '../../routes';
import { CartStore } from '../../stores/CartStore';
import { LoginHelper } from '../../helpers/LoginHelper';
import { Spinner } from '../../common/spinner';
import styles from './LoginValidator.css';

const getDestinationPage = () => {
  // Redirect to the page the user wanted to go to
  const {
    routeName,
    pathParams,
    queryParams,
  } = LoginHelper.getLoginSuccessRoute();
  LoginHelper.clearLoginSuccessRoute();
  if (!routeName) {
    return {
      routeName: routeNaming.HOME,
    };
  }
  return {
    routeName,
    pathParams,
    queryParams,
  };
};

/*
  This component performs some checks that should happen after a successful login.
*/
const LoginValidator = () => {
  if (!CartStore.mergingInProgress) {
    const destinationData = getDestinationPage();
    return (
      <AppRedirect {...destinationData} />
    );
  }
  return <div className={styles.spinnerContainer}><Spinner /></div>;
};

const ObservedLoginValidator = observer(LoginValidator);

export { ObservedLoginValidator as LoginValidator };



// WEBPACK FOOTER //
// ./src/pages/login-validator/LoginValidator.jsx